import classNames from "classnames";
import { BasicProps } from "components/types/BasicProps";
import { ITransfer } from "logic/types/transfers/ITransfer";
import { FC } from "react";
import { accountLiterals } from "../literals";
import { TransferRow } from "./TransferRow";
import LoadingSpinner from "components/LoadingSpinner";

type Props = BasicProps & {
  transfers?: ITransfer[];
};

const {
  title,
  fromTitle,
  dateTitle,
  methodTitle,
  toTitle,
  txHashTitle,
  valueTitle,
  noTransfers,
} = accountLiterals.transfers;

export const Transfers: FC<Props> = (props) => {
  const { transfers, className } = props;

  return (
    <div className={classNames("", className)}>
      <span className="text-2xl font-bold text-uyellow">{title}</span>
      <div className="mt-2 mb-[22px] w-full h-[1px] bg-white"></div>
      <table className="w-full">
        <thead>
          <tr>
            <th className="pr-[15px] max-w-[178px] w-[178px] text-base font-bold">
              {txHashTitle}
            </th>
            <th className="px-[15px] text-base font-bold">{methodTitle}</th>
            <th className="px-[15px] text-base font-bold">{dateTitle}</th>
            <th className="px-[15px] max-w-[178px] w-[178px] text-base font-bold">
              {fromTitle}
            </th>
            <th className="px-[15px] max-w-[178px] w-[178px] text-base font-bold">
              {toTitle}
            </th>
            <th className="px-[15px] max-w-[120px] text-base font-bold">
              {valueTitle}
            </th>
            <th className="pl-[15px] w-[15px] text-base font-bold"></th>
          </tr>
        </thead>
        <tbody>
          {transfers?.map((transfer) => (
            <TransferRow transfer={transfer} key={transfer.txHash} />
          ))}
        </tbody>
      </table>
      {transfers?.length === 0 && (
        <span className="my-[15px]">{noTransfers}</span>
      )}
      {!transfers && (
        <div className="w-full h-28 flex justify-center items-center">
          <LoadingSpinner className="w-10 h-10" />
        </div>
      )}
    </div>
  );
};
